module.exports = __webpack_public_path__ + "40cc0ef69a0181144cb650055fc72e79.svg";